import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { grantEntitlements } from 'api/admin/businesses/entitlements';
import { ApiError } from 'types/api';
import { GrantEntitlementsPayload } from 'types/entitlements/entitlements';

interface GrantEntitlementsOptions {
  successCallback?: () => void;
}

export const useGrantEntitlements = ({ successCallback }: GrantEntitlementsOptions = {}) => {
  return useMutation<unknown, ApiError, GrantEntitlementsPayload>({
    mutationFn: async (payload) => {
      await grantEntitlements(payload);
    },
    onSuccess: () => {
      successCallback?.();
      toast.success('Entitlements granted', { duration: 4000 });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(error?.response?.data?.error ?? 'An error occurred while granting entitlements', {
        duration: 4000,
      });
    },
  });
};
